import messages from '../../../../assets/messages'
import {PammOfferSettingsTradingIntervalType} from '../../../../graphql/types'

type IntervalType = NonNullable<PammOfferSettingsTradingIntervalType['type']>
type MessageDescriptor = {i18nKey: string; defaults: string}

/** Trading interval unit -> i18n message, keyed for singular vs plural counts. */
const INTERVAL_MESSAGES: Record<IntervalType, {singular: MessageDescriptor; plural: MessageDescriptor}> = {
  Days: {singular: messages.day, plural: messages.days},
  Weeks: {singular: messages.week, plural: messages.weeks},
  Months: {singular: messages.month, plural: messages.months},
  CalendarMonths: {singular: messages.calendarMonth, plural: messages.calendarMonths},
}

/**
 * Picks the correct singular/plural i18n unit message for a trading interval
 * (e.g. "1 Day" vs "3 Days"), or `undefined` when the interval type is unknown.
 */
export const getIntervalUnitMessage = (
  interval: PammOfferSettingsTradingIntervalType | null | undefined,
): MessageDescriptor | undefined => {
  if (!interval?.type) return undefined
  const unit = INTERVAL_MESSAGES[interval.type]
  return interval.count === 1 ? unit.singular : unit.plural
}
